import React from 'react';
import { useSubscriptions } from '../../hooks/useSubscriptions';

const PricingTest = () => {
    const { plans, isLoading, isError, error } = useSubscriptions();

    return (
        <div style={{ padding: '20px', fontFamily: 'monospace' }}>
            <h2>Pricing API Test</h2>
            
            <div style={{ marginBottom: '20px' }}>
                <h3>API Data Status:</h3>
                <p>Loading: {isLoading ? 'Yes' : 'No'}</p>
                <p>Error: {isError ? 'Yes' : 'No'}</p>
                <p>Error Message: {error || 'None'}</p>
                <p>Plans Count: {plans ? plans.length : 0}</p>
                {plans && plans.length > 0 && (
                    <div>
                        <h4>API Plans:</h4>
                        <pre>{JSON.stringify(plans, null, 2)}</pre>
                    </div>
                )}
            </div>

            <div style={{ marginBottom: '20px' }}>
                <h3>API Configuration:</h3>
                <p><strong>API Base URL:</strong> {process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001'}</p>
                <p><strong>Plans Endpoint:</strong> /api/subscriptions/plans</p>
                <p><strong>Full URL:</strong> {(process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001') + '/api/subscriptions/plans'}</p>
            </div>

            <div style={{ marginBottom: '20px' }}>
                <h3>Expected Data Format:</h3>
                <pre>{JSON.stringify([
                    {
                        id: 1,
                        plan_name: "Free",
                        base_price: 0,
                        user_limit: 1,
                        ai_tokens_limit: 1000,
                        features: ["API Access", "Email Support", "Basic Dashboard"]
                    }
                ], null, 2)}</pre>
            </div>
        </div>
    );
};

export default PricingTest; 